var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-offline',{attrs:{"online-class":"online","offline-class":"offline"},on:{"detected-condition":_vm.amIOnline}},[(_vm.online)?[_c('RouterView')]:_vm._e(),(!_vm.online)?[_c('offline')]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }